import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import Tooltip from 'components/common/Tooltip';
import Link from 'components/common/Link';
import IconDocument from 'components/icons/IconDocument';

import Avatar from 'components/common/Avatar';

const styles = theme => ({
  root: {
    display: 'flex',
    margin: '8px 24px',
    justifyContent: 'flex-start',
    [theme.breakpoints.down('sm')]: {
      margin: '8px 8px',
    },
  },
  blob: {
    position: 'relative',
    maxWidth: '70%',
    padding: 8,
    backgroundColor: theme.palette.grey[100],
    borderRadius: 8,
    '&:after': {
      content: '""',
      display: 'block',
      position: 'absolute',
      top: 8,
      left: -4,
      width: 16,
      height: 16,
      transform: 'rotate(45deg)',
      backgroundColor: theme.palette.grey[100],
      zIndex: -1,
    },
  },
  rootUser: {
    justifyContent: 'flex-end',
    '& $blob:after': {
      left: 'auto',
      right: -4,
    },
    '& $tooltip': {
      marginLeft: 16,
      marginRight: 0,
    },
  },
  rootCurrentUser: {
    '& $blob': {
      backgroundColor: theme.palette.primary[100],
      '&:after': {
        backgroundColor: theme.palette.primary[100],
      },
    },
  },
  avatar: {
    width: 32,
    height: 32,
  },
  avatarPlaceholder: {
    width: 32,
    height: 32,
    lineHeight: '32px',
    textAlign: 'center',
    borderRadius: '50%',
    fontWeight: 'bold',
    color: theme.palette.common.white,
    backgroundColor: theme.palette.primary.A400,
    cursor: 'pointer',
  },
  tooltip: {
    width: 32,
    height: 32,
    paddingTop: 8,
    marginTop: -8,
    marginRight: 16,
  },
  image: {
    maxWidth: '100%',
    height: 100,
    width: 'auto',
  },
  iconDocument: {
    width: 16,
    height: 20,
    margin: '5px 16px 0 3px',
    color: theme.palette.primary.A400,
  },
  filePlaceholder: {
    display: 'flex',
  },
});

const NotificationsDialogItem = ({
  Message,
  Sender,
  classes,
  User,
  Time,
  Media,
  account,
  onDocumentView,
  ...otherProps
}) => {
  let avatarImageSrc;
  if (User.Image && User.Image.ID) {
    avatarImageSrc = process.env.REACT_APP_API_ROOT
      ? `${process.env.REACT_APP_API_ROOT}${User.Image['File Url']}${User.Image['File Name']}`
      : `${User.Image['File Url']}${User.Image['File Name']}`;
  }
  let mediaImageSrc
  if (Media && Media.ID) {
    mediaImageSrc = process.env.REACT_APP_API_ROOT
      ? `${process.env.REACT_APP_API_ROOT}${Media['File Url']}${Media['File Name']}`
      : `${Media['File Url']}${Media['File Name']}`;
  }
  return (
    <div className={classNames(classes.root, {
      [classes.rootUser]: Sender === 'User',
      [classes.rootCurrentUser]: User.ID === account.ID,
    })}>
      {Sender === 'Patient' && (
        <Tooltip
          className={classes.tooltip}
          content={`${otherProps['First Name']} ${otherProps['Last Name']}`}
          placement="top"
          color="dark"
          disableGutters
        >
          <Typography className={classes.avatarPlaceholder}>
            {otherProps['First Name'].slice(0, 1)}
            {otherProps['Last Name'].slice(0, 1)}
          </Typography>
        </Tooltip>
      )}
      <div className={classes.blob}>
        {Message &&
          <Typography>
            {Message}
          </Typography>
        }
        {(Media && Media.ID) && (
          <Link
            onClick={() => {
              onDocumentView(Media);
            }}
          >
            {['image/jpeg', 'image/png'].indexOf(Media['File Type']) !== -1 ? (
              <img
                src={mediaImageSrc}
                alt={Media['File Name']}
                className={classes.image}
              />
            ) : (
              <div className={classes.filePlaceholder}>
                <IconDocument className={classes.iconDocument} />
                <div>
                  <Typography gutterBottom>
                    {Media['File Name']}
                  </Typography>
                  <Typography variant="caption">
                    {Media['File Size']}
                  </Typography>
                </div>
              </div>
            )} 
          </Link>
        )}
        <Typography variant="caption" align="right">
          {Time}
        </Typography>
      </div>
      {Sender === 'User' && (
        <Tooltip
          className={classes.tooltip}
          content={`${User['First Name']} ${User['Last Name']}`}
          placement="top"
          color="dark"
          disableGutters
        >
          <Avatar
            className={classes.avatar}
            src={avatarImageSrc}
          />
        </Tooltip>
      )}
    </div>
  );
};

NotificationsDialogItem.propTypes = {
  Time: PropTypes.string.isRequired,
  Message: PropTypes.string,
  Sender: PropTypes.string.isRequired,
  account: PropTypes.shape({
    ID: PropTypes.number,
  }),
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    blob: PropTypes.string.isRequired,
    avatar: PropTypes.string.isRequired,
    avatarPlaceholder: PropTypes.string.isRequired,
  }).isRequired,
};

NotificationsDialogItem.defaultProps = {
  Message: null,
};

export default withStyles(styles)(NotificationsDialogItem);



// WEBPACK FOOTER //
// ./src/components/patient/NotificationsDialog/NotificationsDialogItem.js